import React from 'react'
import {Helmet} from "react-helmet";
import PageTitle from '../../../pagetitle/PageTitle'
import GumusSponsorCard from '../../../sponsorcard/GumusSponsorCard'

export default function GumusSponsorlar()
{
    const title = "OKAF Gümüş Sponsorlar- Samsun Üniversitesi";
    const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'ın gümüş sponsorlarına ulaşmak için tıklayınız!";
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <PageTitle name="Gümüş Sponsorlar"></PageTitle>
            { <GumusSponsorCard /> }
        </>
    )
}
